import { AppHelper } from "../../appHelper";
import { CommonApp, Context, Entity, Metadata } from "../../core/components/commonApp";
import { TaskState, TaskProps, RecurringTaskEntity } from "./recurringTask";
import { General } from "../../../siteManagement/general";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { PageTitleProps } from "../../core/components/pageTitle";
import React from "react";

export default class ChangeTaskPeriodApp extends React.Component<ChangeTaskPeriodAppProps, any> {
    common = new AppHelper();
    sheet: Sheet;

    constructor(props: ChangeTaskPeriodAppProps) {
        super(props);
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Custom, (data: any) => {
            if (Helper.hasValue(data) && data.command === "reset") {
                this.handleFieldChange({ model: data.field }, null);
            }
        });
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        let prop = this.matchMergedProp(field.model);
        if (Helper.hasValue(prop))
            this.updateProp(prop, value);
        else if (field.model === "entity.MaxExecutions")
            this.common.handleFieldChange({ model: 'entity.MaxExecutions' }, value);
    }

    matchMergedProp = (fieldName: string): string => {
        let match = fieldName.match(/^entity\.(?:MergedProps|ExplicitProps)\.(\w+)$/);
        if (Helper.hasValue(match))
            return match[1];
        else
            return null;
    }

    updateProp = (prop: string, value: any) => {
        this.common.handleFieldChange({ model: 'entity.ExplicitProps.' + prop }, value);
        let parentValue = MetaDataHelper.getFieldValue(this.props.entity, 'entity.ParentProps.' + prop);
        let mergedValue = value;
        if (Helper.isNullOrEmpty(value) && Helper.hasValue(parentValue))
            mergedValue = parentValue;
        this.common.handleFieldChange({ model: 'entity.MergedProps.' + prop }, mergedValue);
    }

    save = () => {
        if (this.common.validate())
            this.common.handlePostSave(true);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
        };
        return (<CommonApp {...props} titleProps={titleProps} />);
    }
}

export interface ChangeTaskPeriodAppProps {
    entity: ChangePeriodEntity;
    title: string;
    metadata: Metadata;
    context: Context;
}

export interface ChangePeriodEntity extends Entity {
    MergedProps: TaskProps;
    ParentProps: TaskProps;
    ExplicitProps: TaskProps;
    TaskId: string;
    TriggeredCount?: number;
    LastExecutionOn?: string;
    MaxExecutions: number;
}
